

<!-- Modal -->
<div class="modal" id="unlock_course" tabindex="-1" role="dialog" aria-labelledby="unlock_courseModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Create your account</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

              <mat-tab-group class="test-series-tabs" (selectedIndexChange)="customLoginTabsChange($event)" #tsTab>
                <mat-tab  *ngFor="let ts of customLoginTabs" label="{{ts.cat_name}}">
                </mat-tab>
              </mat-tab-group>

              <ng-container *ngIf="selectedLoginIndex == 0">
                <div [hidden]="isMsg" [innerHTML]="message | sanatizeHtml"></div>
                <div class="create-account-form-area">

                    <form *ngIf="registerForm" [formGroup]="registerForm" (ngSubmit)="onSubmit()" role="form"  class="form-style-one">
                        <div class="frm-group">
                          <input type="text" formControlName="name" (keypress)="textOnly($event)" placeholder="Name (Optional)">
                          <span *ngIf="submitted && f.name.errors" class="error">
                              <span *ngIf="f.name.errors.required">Name is required.</span>
                          </span>
                       </div>

                        <div class="frm-group">
                            <input type="email" formControlName="email" placeholder="Email">
                            <span *ngIf="submitted && f.email.errors" class="error">
                                <span *ngIf="f.email.errors.required">Email id is required.</span>
                                <span *ngIf="f.email.errors.email">Email must be a valid email address</span>
                            </span>
                        </div>

                        <div class="frm-group">
                                <input type="password" formControlName="password" placeholder="Type password">
                                <div *ngIf="submitted && f.password.errors" class="error" >
                                    <div *ngIf="f.password.errors.required">Password is required</div>
                                    <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                                </div>
                        </div>

                        <div class="frm-group" *ngIf="isZoneEnabled">
                          <select formControlName="customer_zone" class="form-control" (focus)="fetchZones()">
                            <option value="">Zone</option>
                            <option *ngFor="let zone of zones" [value]="zone.id">{{zone.name}}</option>
                          </select>
                          <div *ngIf="submitted && f.customer_zone.errors" class="error" >
                            <div *ngIf="f.customer_zone.errors.required">Zone is required</div>
                        </div>
                        </div>

                        <div class="frm-group" *ngIf="interest">
                          <input type="text" formControlName="course_interested" placeholder="Enter Course Interest">
                          <span *ngIf="submitted && f.course_interested.errors" class="error">
                              <span *ngIf="f.course_interested.errors.required">Course is required.</span>
                          </span>
                       </div>

                        <div class="frm-group" *ngIf="state_city">
                          <select formControlName="state_id" class="form-control" (change)="onChangeState($event.target.value)" (focus)="fetchStates()">
                            <option value="">State</option>
                            <option *ngFor="let state of states" [value]="state.id">{{state.name}}</option>
                          </select>
                          <div *ngIf="submitted && f.state_id.errors" class="error" >
                            <div *ngIf="f.state_id.errors.required">State is required</div>
                        </div>
                        </div>
                        <div class="frm-group" *ngIf="cities.length>0 && state_city">
                          <select formControlName="city_id" class="form-control">
                            <option value="">City</option>
                            <option *ngFor="let city of cities" [value]="city.id">{{city.name}}</option>
                          </select>
                          <div *ngIf="submitted && f.city_id.errors" class="error" >
                            <div *ngIf="f.city_id.errors.required">City is required</div>
                        </div>
                        </div>

                        <div class="frm-group">
                          <input type="tel" formControlName="mobile" (keypress)="numberOnly($event)" placeholder="Mobile Number" maxlength="10" minlength="10">
                          <span *ngIf="submitted && f.mobile.errors" class="error">
                              <span *ngIf="f.mobile.errors.required">Mobile number is required.</span>
                          </span>
                        </div>

                        <ng-container *ngIf="isOtpEnabled && !submitted">
                          <ng-container *ngIf="f.mobile && f.mobile.valid && regBtn">
                            <div class="buyCta__opt">
                              <div *ngIf="isFirstTime">
                                <button [disabled]="getOTPclicked" class="btn btn-primary btn-block" id="subs_button" type="button" (click)="getRegisterMobileNoExists()" style="    width: fit-content;">Get OTP</button>
                              </div>
                                <div *ngIf="!isFirstTime">
                                  <button [disabled]="getOTPclicked" class="btn btn-primary btn-block" id="subs_button" type="button" (click)="getRegisterMobileNoExists()" style="    width: fit-content;">Resend OTP</button>
                                </div>
                            </div>


                            <div class="min-sec-timer" *ngIf="getOTPclicked && otpFetched && regBtn">
                              <span id="minutes"> {{minutesToDday}} </span>Min :
                              <span id="seconds"> {{secondsToDday}} </span>Sec
                            </div>

                            <div class="frm-group" *ngIf="otpFetched && regBtn" style="
                            margin-top: 8px;
                        ">
                              <input type="text" formControlName="otp"
                              placeholder="Enter OTP No" [ngModel]="otp">
                            </div>

                            <div style="padding-top: 10px;"  *ngIf="otpFetched && regBtn">
                              <button [disabled]="f.otp.value.length != 4" (click)="verifyMobile()" type="button" class="btn btn-info btn-block btn-warning" style="    width: fit-content;">Verify</button>
                            </div>
                          </ng-container>

                          <div *ngIf="isverified">
                            <div *ngIf="verify_message" id="user_sucess_msg" [innerHtml]="verify_message | sanatizeHtml"></div>
                          </div>
                          <div *ngIf="error_message" id="user_error_msg" [innerHtml]="error_message | sanatizeHtml"></div>
                        </ng-container>

                        <div class="frm-group mt-2">
                            <button type="submit" id="regg_btn" class="apply-btn" [disabled]="regBtn">Create Account</button>
                            <!-- <div class="alread-have"> Already have an account? &nbsp;
                                <a (click)='closeModel()' routerLink="/sign-in" class="account-log-btn">Login </a>
                            </div> -->
                        </div>
                    </form>

                    <div class="clearfix"></div>
                    <div class="text-center social-btn loning-prt"  *ngIf="socialLogin">
                        <a href="javascript:void(0)" class="btn btn-primary btn-blocks" (click)="login()"><i class="fa fa-facebook"></i> Sign in with <b>Facebook</b></a>
                        <a href="javascript:void(0)" class="btn btn-danger btn-blocks pds" (click)="loginWithGoogle()"><i class="fa fa-google"></i> Sign in with <b>Google</b></a>
                    </div>
                </div>
              </ng-container>
             <div class="p-3">
              <ng-container *ngIf="selectedLoginIndex == 1">
                <div [hidden]="isMsg" [innerHTML]="message | sanatizeHtml"></div>
                <ng-container *ngIf="isMobileLogin">
                  <form *ngIf="mobileForm" [formGroup]="mobileForm" (ngSubmit)="onLoginSubmit()" role="form"  class="form-style-one">

                  <div class="frm-group">
                    <input type="tel" formControlName="mobile" (keypress)="numberLoginOnly($event)" placeholder="Mobile Login" maxlength="10" minlength="10">
                    <span *ngIf="submitted && g.mobile.errors && !isEmailLoginClicked" class="error">
                        <span *ngIf="g.mobile.errors.required">Mobile number is required.</span>
                    </span>
                  </div>

                  <ng-container *ngIf="!submitted">
                    <ng-container *ngIf="g.mobile.valid">
                      <div class="buyCta__opt" style="margin-top: 12px;">
                        <div *ngIf="isFirstTime">
                          <button [disabled]="getOTPclicked" class="btn btn-primary btn-block" id="subs_button" type="button" (click)="getMobileNoExists()" style="    width: fit-content;">OTP Login</button>
                        </div>
                          <div *ngIf="!isFirstTime">
                            <button [disabled]="getOTPclicked" class="btn btn-primary btn-block" id="subs_button" type="button" (click)="getMobileNoExists()" style="    width: fit-content;">Resend OTP</button>
                          </div>
                      </div>


                      <div class="min-sec-timer" *ngIf="getOTPclicked && otpFetched">
                        <span id="minutes"> {{minutesToDday}} </span>Min :
                        <span id="seconds"> {{secondsToDday}} </span>Sec
                      </div>

                      <div class="frm-group" *ngIf="otpFetched" style="
                      margin-top: 8px;
                  ">
                        <input type="text" formControlName="otp"
                        placeholder="Enter OTP No" [ngModel]="otp">
                      </div>

                      <div style="padding-top: 10px;"  *ngIf="otpFetched">
                        <button [disabled]="g.otp.value.length != 4" (click)="verifyLoginMobile()" type="button" class="apply-btn cust-green" style="    width: fit-content;">Confirm</button>
                      </div>
                    </ng-container>
                  </ng-container>

                  <div>
                    <div *ngIf="verify_message" id="user_sucess_msg" [innerHtml]="verify_message | sanatizeHtml"></div>
                    <div *ngIf="error_message" id="user_error_msg" [innerHtml]="error_message | sanatizeHtml"></div>
                  </div>

                </form>
                </ng-container>

                <ng-container *ngIf="isMobileLogin && isEmailLogin">
                  <div style="    padding: 4px 10px;
                  background: black;
                  color: white;
                  font-weight: 700;
                  width: fit-content;
                  margin-top: 25px;
                  margin-bottom: 25px;
                  border-radius: 10px;">OR</div>
                </ng-container>
                <!-- <p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below</p> -->
                <ng-container *ngIf="isEmailLogin">
                  <form *ngIf="loginForm" [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()" role="form"  class="form-style-one">

                    <div class="frm-group">
                        <input type="email" formControlName="email" placeholder="Email/Mobile">
                        <!-- <span *ngIf="submitted && k.email.errors && isEmailLoginClicked" class="error">
                            <span *ngIf="k.email.errors.required">Email id is required.</span>
                            <span *ngIf="k.email.errors.email">Email must be a valid email address</span>
                        </span> -->
                    </div>

                    <div class="frm-group">
                        <input type="password" formControlName="password" placeholder="Password">
                        <div *ngIf="submitted && k.password.errors && isEmailLoginClicked" class="error" >
                            <div *ngIf="k.password.errors.required">Password is required</div>
                        </div>
                    </div>

                   
                    <div class="frm-group">
                        <button type="submit" class="btn" id="logBtn"  style="border-radius: 3px;
                           border-color: #a88734 #9c7e31 #846a29;
color: #111;box-shadow: 0 1px 0 rgb(255 255 255 / 40%) inset  !important;   background: linear-gradient(to bottom,#f7dfa5,#f0c14b) !important;     color: black;
                        width: 100%;"> Continue </button>
    
                    </div>

                    <div>

                      <!-- <div>
                        By continuing, you agree to {{titleName}}'s <a routerLink="/terms-conditions" style="color: #019ee3;">Conditions of Use</a> and <a routerLink="/privacy-policy" style="color: #019ee3;">Privacy Notice</a>.
                      </div> -->
                      <!-- <div style="margin-top: 15px;    margin-bottom: 10px;">
                        <a routerLink="/forgot-password" class="forget_password" style="color: #019ee3;"> Forgot Password</a>
                      </div> -->
                      <!-- <ng-container *ngIf="linkToAllow['RegisterModule']">

                        <div class="a-divider a-divider-break" >
                         <div style="background: white;">
                              <p style="   line-height: 1;
                              font-size: 12px;
                              color: #767676;
                              font-weight: 400;
                              z-index: 2;
                              position: relative;
                              display: inline-block;
                              background-color: #fff;
                              padding: 0 8px 0 7px;">New to {{titleName}}?</p>
                         </div>
                        </div>
                        <div > 
                          <a routerLink="/sign-up" class="btn" style="background: linear-gradient(to bottom,#f7f8fa,#e7e9ec) !important;box-shadow: 0 1px 0 rgb(255 255 255 / 60%) inset !important;  border-radius: 3px;
                          border-color: #adb1b8 #a2a6ac #8d9096;  color: #111;
                          border-radius: 2px;    width: 100%;">
                             Create your {{titleName}} account
                          </a>
                        </div>
                      </ng-container> -->
                    </div>
                </form>
                  </ng-container>
              </ng-container>
             </div>
                
            </div>

        </div>
    </div>
</div>





